// extracted by mini-css-extract-plugin
export default {"marqueeContainer":"Marquee_marqueeContainer__2McGP","marqueeText":"Marquee_marqueeText__WzOrF","marquee":"Marquee_marquee__YxRsT","loadingSpinner":"Marquee_loadingSpinner__qPiwF"};